import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/product.models';
import {
  FinanceOverviewDto,
  DebtAgingDto,
  RecurringExpenseDto,
  CreateRecurringExpenseRequest,
  UpdateRecurringExpenseRequest,
} from '../models/finance.models';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class FinanceService extends ApiService {
  private readonly base = `${environment.apiUrl}/api/Finance`;
  private readonly recurring = `${environment.apiUrl}/api/RecurringExpenses`;

  getOverview(
    from: string,
    to: string,
    storeId?: string,
    currency?: string,
  ): Observable<ApiResponse<FinanceOverviewDto>> {
    let params = new HttpParams().set('from', from).set('to', to);
    if (storeId) params = params.set('storeId', storeId);
    // Berilmasa backend kotirovka valyutasini oladi — eski chaqiruvlar o'zgarmaydi.
    if (currency) params = params.set('currency', currency);
    return this.http.get<ApiResponse<FinanceOverviewDto>>(`${this.base}/overview`, { params });
  }

  /**
   * Qarzlarning muddat bo'yicha taqsimoti. Davr parametri yo'q — joriy holat
   * ko'rsatiladi (qarz "qaysi oyda berilgani" emas, "qancha vaqtdan beri turgani" muhim).
   */
  getDebtAging(storeId?: string, currency?: string): Observable<ApiResponse<DebtAgingDto>> {
    let params = new HttpParams();
    if (storeId) params = params.set('storeId', storeId);
    if (currency) params = params.set('currency', currency);
    return this.http.get<ApiResponse<DebtAgingDto>>(`${this.base}/debt-aging`, { params });
  }

  getRecurring(): Observable<ApiResponse<RecurringExpenseDto[]>> {
    return this.http.get<ApiResponse<RecurringExpenseDto[]>>(this.recurring);
  }

  createRecurring(data: CreateRecurringExpenseRequest): Observable<ApiResponse<{ id: string }>> {
    return this.http.post<ApiResponse<{ id: string }>>(this.recurring, data);
  }

  updateRecurring(id: string, data: UpdateRecurringExpenseRequest): Observable<unknown> {
    return this.http.put(`${this.recurring}/${id}`, data);
  }

  deleteRecurring(id: string): Observable<unknown> {
    return this.http.delete(`${this.recurring}/${id}`);
  }
}
